import { REGISTRATION_TYPE_LABEL } from '@exam-center/exam-event-management';
import { type SearchExamEventsWithQuestionnairesQuery } from '@exam-center/graphql';
import { dayjs, formatNumber } from '@shared/utils';

import { type AdminQuestionnaireExportItem } from '../../components';

type ExamEventWithQuestionnaire =
  SearchExamEventsWithQuestionnairesQuery['ecSearchExamEventsWithQuestionnaires']['data'][number];

export function mapAdminQuestionnaireExportItemToRow(
  data: ExamEventWithQuestionnaire,
): AdminQuestionnaireExportItem {
  const { examEvent, questionnaireCount } = data;

  const startTime = dayjs(examEvent.examStartedAt).format('HH:mm');
  const endTime = dayjs(examEvent.examEndedAt).format('HH:mm');
  const examTime = `${startTime} - ${endTime}`;

  const location = examEvent.examLocation.nameTh;
  const province = examEvent.examLocation.province.nameTh;

  const examDate = dayjs(examEvent.examStartedAt).format('DD-MM-YYYY');

  return {
    id: examEvent.id,
    examDate,
    examTime,
    round: examEvent.roundNumber,
    regType: REGISTRATION_TYPE_LABEL[examEvent.registrationType],
    examCenterName: examEvent.examCenter.nameTH,
    examCenterCode: examEvent.examCenter.code,
    title: examEvent.name,
    location,
    province,
    responses: formatNumber(questionnaireCount),
  };
}
